import { TUTOR_CLASSES, ALL_TUTOR_SUBJECTS } from "@/lib/tutorConfig";

// Renders a "Home Tutor preferences" section. Only relevant when partner offers Home Tutor service.
export default function TutorProfileSection({ value, onChange }) {
  const v = value || { classes: [], subjects: [] };
  const toggle = (key, item) => {
    const list = v[key] || [];
    const next = list.includes(item) ? list.filter((x) => x !== item) : [...list, item];
    onChange({ ...v, [key]: next });
  };

  return (
    <div className="rounded-xl border border-[#1E3F20]/30 bg-[#F3F1ED] p-5" data-testid="tutor-profile-section">
      <div className="text-xs uppercase tracking-widest text-[#1E3F20] font-semibold">
        Home Tutor preferences
      </div>
      <p className="text-xs text-[#737373] mt-1">
        You will only see tutor leads that match these classes and subjects.
      </p>

      <div className="mt-4">
        <label className="text-sm font-medium">Classes you teach</label>
        <div className="grid grid-cols-3 md:grid-cols-5 gap-2 mt-2">
          {TUTOR_CLASSES.map((c) => {
            const active = (v.classes || []).includes(c);
            return (
              <button
                key={c}
                type="button"
                onClick={() => toggle("classes", c)}
                className={`text-xs font-medium p-2 rounded-lg border text-center transition-colors ${active ? "bg-[#1E3F20] text-white border-[#1E3F20]" : "bg-white border-[#E5E3DB] hover:border-[#1E3F20]"}`}
                data-testid={`tutor-pref-class-${c.replace(/\s/g, "-").toLowerCase()}`}
              >
                {c}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-4">
        <label className="text-sm font-medium">Subjects you teach (Class 6+)</label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2">
          {ALL_TUTOR_SUBJECTS.map((s) => {
            const active = (v.subjects || []).includes(s);
            return (
              <button
                key={s}
                type="button"
                onClick={() => toggle("subjects", s)}
                className={`text-xs font-medium p-2 rounded-lg border text-center transition-colors ${active ? "bg-[#1E3F20] text-white border-[#1E3F20]" : "bg-white border-[#E5E3DB] hover:border-[#1E3F20]"}`}
                data-testid={`tutor-pref-subject-${s.replace(/\s|&/g, "-").toLowerCase()}`}
              >
                {s}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
